import { Component } from '@angular/core';

@Component({
  selector: 'app-payment-failure',
  imports: [],
  templateUrl: './payment-failure.component.html',
  styleUrl: './payment-failure.component.scss'
})
export class PaymentFailureComponent {

}
